import { render, staticRenderFns } from "./ScoreStartMachineList.vue?vue&type=template&id=481a0caa&"
import script from "./ScoreStartMachineList.vue?vue&type=script&lang=js&"
export * from "./ScoreStartMachineList.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStartMachineList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports